<template>
<div>

<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData"  :labelWidth="120"></compFormEdit>
  <vButtonGroup class="text-right">
          <vButton @click="submit" theme="primary">{{$t('global.modal.confirm', { defaultValue: "确定" })}}</vButton>
          <vButton @click="cancel">{{$t('global.common.cancel', { defaultValue: "取消" })}}</vButton>
  </vButtonGroup>
  <vLoading loading size="large" transfer v-if="loading"></vLoading>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
    HttpSaveGateShop,
    HttpGateShopGetOne
} from "@/service/basicdata";
export default {
  props: ["activeid","type"],
  created() {
    this.getDetail();
  },
  data() {
    return {
      loading: false,
      id:  this.activeid,
      formData: {
      },
      required: [
        {
          required: true,
          message: "该信息不能为空,请填写"
        }
      ],
    };
  },
  computed: {
      ...mapGetters('dictionary', ['getCountryList']),
      isQuery() {
          return this.type === "query";
      },
        
      isAdd() {
        return this.type === 'add'
      },
     getBase() {
			return [{
              label: this.$t('fbb.basic.gateshop_code',{defaultValue:'地址Code'}),
              key: "code",
              query:!this.isAdd,
              tag:'vInput',
              },{
               label: this.$t('erp.channelbase.country',{defaultValue:'国家'}),
              key: "country",
              tag:'Select',
              query:this.isQuery,
              options:this.getCountryList,
               on: {
              'on-attach': val => {
                this.formData.country = val;
              }
              }
              },{
              label: this.$t('erp.b2c.state_province',{defaultValue:'州'}),
              key: "state",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('erp.b2c.city',{defaultValue:'城市'}),
              key: "city",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('erp.b2c.zip_code',{defaultValue:'邮编'}),
              key: "postal",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('fbb.headlogistics.address_detail',{defaultValue:'详细地址'}),
              key: "address",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('erp.b2c.address2',{defaultValue:'地址2'}),
              key: "address2",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('erp.b2border.linkman',{defaultValue:'联系人'}),
              key: "linkman",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('global.common.mobile',{defaultValue:'移动电话'}),
              key: "mobilePhone",
              query:this.isQuery,
              tag:'vInput',
              },{
              label: this.$t('erp.b2c.phone',{defaultValue:'电话'}),
              key: "phone",
              query:this.isQuery,
              required:false,
              tag:'vInput',
              },{
              label: this.$t('global.common.email',{defaultValue:'邮箱'}),
              key: "email",
              query:this.isQuery,
              required:false,
              tag:'vInput',
              },{
              label: this.$t('fbb.accountmanage.description',{defaultValue:'描述'}),
              key: "description",
              query:this.isQuery,
              required:false,
              tag:'vTextarea',
              }
      ];
     }
        
  },
  methods: {
      getDetail() {
      if (this.isAdd) return;
      this.loading = true;
      if(this.id){
          HttpGateShopGetOne({ id: this.id }).then(res => {
					
          this.formData = res.data;
          	this.loading = false;
				}).catch(err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				})
      }
    },
    
    async submit(){
        const valid = await this.$refs.formbase.validate();
        if (!valid) return;
        this.loading = true;
        HttpSaveGateShop({
         ...this.formData
        })
          .then(res => {
            this.loading = false;
            this.$VMessage.success(this.$t('fbb.logistics.cost_add_success', { defaultValue: '添加成功' }));
            this.success();
          }, err => {
            this.loading = false;
                this.$VMessage.error(err.message)
            });
    },
   
    success() {
      this.$emit("on-close");
      this.$emit("on-update");
      this.$emit("refreshPage");
    },
    cancel() {
      this.$emit("on-close");
    }
  }
};
</script>
